export default function () {
  return [
    // Dashboard
    {
      title: 'Painel de controle',
      name: 'dashboard',
      to: {
        name: 'admin-overview',
      },
      htmlBefore: '<i class="material-icons">dashboard</i>',
    },
    // Lead
    {
      title: 'Indicações',
      name: 'leads',
      to: {
        name: 'admin-lead-list',
        params: {
          page: 1,
        },
      },
      htmlBefore: '<i class="material-icons">location_on</i>',
    },
    // Reseller
    {
      title: 'Lojas Parceiras',
      name: 'resellers',
      isReseller: false,
      to: {
        name: 'admin-reseller-list',
        params: {
          page: 1,
        },
      },
      htmlBefore: '<i class="material-icons">contacts</i>',
      items: [
        {
          title: 'Lista',
          to: {
            name: 'admin-reseller-list',
            params: {
              page: 1,
            },
          },
        },
        {
          title: 'Adicionar',
          to: {
            name: 'admin-reseller-new',
          },
        },
      ],
    },
    // Reseller Perfil
    // {
    //   title: 'Perfil da Loja',
    //   name: 'resellers',
    //   isReseller: true,
    //   isAdmin: false,
    //   to: {
    //     name: 'admin-reseller-perfil',
    //   },
    //   htmlBefore: '<i class="material-icons">contacts</i>',
    // },
    // User
    // Representative
    {
      title: 'Representante',
      name: 'representatives',
      isCommercial: true,
      htmlBefore: '<i class="material-icons">record_voice_over</i>',
      to: {
        name: 'admin-representative-list',
        params: {
          page: 1,
        },
      },
      items: [
        {
          title: 'Lista',
          to: {
            name: 'admin-representative-list',
            params: {
              page: 1,
            },
          },
        },
      ],
    },
    {
      title: 'Usuários',
      name: 'users',
      to: {
        name: 'admin-user-list',
        params: {
          page: 1,
        },
      },
      htmlBefore: '<i class="material-icons">perm_identity</i>',
      items: [
        {
          title: 'Lista',
          to: {
            name: 'admin-user-list',
            params: {
              page: 1,
            },
          },
        },
        {
          title: 'Adicionar',
          to: {
            name: 'admin-user-new',
          },
        },
      ],
    },
  ];
}
